module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12",
    staticStyle: {
      "border-right": "2px solid #999"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "30px",
      "display": "inline"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.fecha = $event
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {},
    on: {
      "click": function($event) {
        return _vm.actualizar()
      }
    }
  }, [_vm._v(" ACTUALIZAR ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.tablaConteo), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center"
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k,
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(" " + _vm._s(r) + " ")])
    }), 0)
  }), _vm._v(" "), _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.sitiosTotal) + " ")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._m(3), _vm._v(" "), _vm._l((_vm.tablaFuera), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center",
      attrs: {
        "id": 'alarm-' + key
      }
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k
      }, [_vm._v(_vm._s(r))])
    }), 0)
  }), _vm._v(" "), _vm._m(4)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "height": "50vh"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._m(6), _vm._v(" "), _vm._l((_vm.tablaInfo), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center",
      attrs: {
        "id": 'alarm-' + key
      }
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k,
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(" " + _vm._s(r) + " ")])
    }), 0)
  }), _vm._v(" "), _vm._m(7)], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Conteo General de Eventos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Ducto")]), _vm._v(" "), _c('td', [_vm._v("Alarmas")]), _vm._v(" "), _c('td', [_vm._v("Sitios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Estaciones Fuera de Línea")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', [_vm._v(" Ducto ")]), _vm._v(" "), _c('td', [_vm._v(" Estación ")]), _vm._v(" "), _c('td', [_vm._v(" Última Recepción ")]), _vm._v(" "), _c('td', [_vm._v(" Horas Activo ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Información General Ductos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', [_vm._v(" Ducto ")]), _vm._v(" "), _c('td', [_vm._v(" No. Est ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Inicial ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Final ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Total ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("111")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("000")]), _vm._v(" "), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14af0ed9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Direccion/General.vue
// module id = 1685
// module chunks = 6